import { FC } from 'react';

import ErrorPage from '@components/ui/ErrorPage/ErrorPage';

const SitecoreErrorPage: FC<{ fields: { statusCode: { value: number } } }> = ({ fields: { statusCode } }) => (
  <ErrorPage errorStatusCode={statusCode.value} />
);

export default SitecoreErrorPage;
